import { Box, Typography, Divider } from '@mui/material';
import DividiTotaleComanda from '../components/DividiTotaleComanda';
import { useTranslation } from 'react-i18next';
import { getTenantTranslation } from '../utils/getTenantTranslation';

function ModalDettaglioComanda({ comanda, onClose }) {
  const { t } = useTranslation();
  const tenantType = localStorage.getItem('tenantType');
  
  const prodottiComanda = comanda?.orderProducts || [];
  
  const calcolaTotale = () => {
    return prodottiComanda.reduce((tot, p) => {
      return tot + ((p.product?.price || 0) * p.quantity);
    }, 0);
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        {t("orderDetail")} {comanda?.table?.name || `${getTenantTranslation(t, tenantType, 'selectTable')} ${comanda?.tableId}`}
      </Typography>

      {prodottiComanda.length > 0 ? (
        prodottiComanda.map((p) => (
          <Box key={p.id} display="flex" justifyContent="space-between" my={1}>
            <Typography>
              {p.product?.name || `Prodotto #${p.productId}`} × {p.quantity}
            </Typography>
            <Typography>
              {((p.product?.price || 0) * p.quantity).toFixed(2)}€
            </Typography>
          </Box>
        ))
      ) : (
        <Typography variant="body2" color="text.secondary">
          {t("noProductPresent")}.
        </Typography>
      )}

      <Divider sx={{ my: 2 }} />
      <DividiTotaleComanda
        totaleComanda={calcolaTotale()}
        onClose={onClose}
      />
    </Box>
  );
}

export default ModalDettaglioComanda;